import { render, staticRenderFns } from "./AgoraRtcMonitor.vue?vue&type=template&id=79ca1ac8&scoped=true&"
import script from "./AgoraRtcMonitor.vue?vue&type=script&lang=js&"
export * from "./AgoraRtcMonitor.vue?vue&type=script&lang=js&"
import style0 from "./AgoraRtcMonitor.vue?vue&type=style&index=0&id=79ca1ac8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ca1ac8",
  null
  
)

export default component.exports